// extracted by mini-css-extract-plugin
module.exports = {"regular":"SimpleTextList_regular__17RwW","highlighted":"SimpleTextList_highlighted__II1St","container":"SimpleTextList_container__3lV-D"};